import { OverlayRef } from '@angular/cdk/overlay';

export class BookingInfoOverlayRef {
  public constructor(private _overlayRef: OverlayRef) {}

  public close(): void {
    this._overlayRef.dispose();
  }
}
